import { createComponent } from '@lit-labs/react';
import React from 'react';
import { CustomValidity, Replacement } from './';
export class DateInputDS extends HTMLElement {
  required?: boolean;
  label?: string;
  class?: string;
  value: unknown;
  date?: Date;
  replacement?: string | Replacement[];
  customValidityPattern?: string | CustomValidity[];
  constructor() {
    super();
  }
}

export const DateInput = createComponent(React, 'date-input', DateInputDS, {
  onInputChange: 'input-changed',
  onFocus: 'element-focused',
  onLetterChanged: 'letter-changed',
  onBlur: 'element-blured',
});
